import { Text } from "@mantine/core";
import classes from "./RenderText.module.css";

interface RenderTextProps {
  text: string | number;
  isAmount?: boolean;
  color?: string;
  fontWeight?: number;
  component?: any;
}

const RenderText = ({ text, isAmount = false, color = "dark.5", fontWeight = 400, component }: RenderTextProps) => (
  <Text
    size="sm"
    fw={fontWeight}
    c={color}
    ta={isAmount ? "end" : undefined}
    w={isAmount ? undefined : "max-content"}
    className={isAmount ? classes.nowrap : undefined}
    component={component ? component : undefined}>
    {text}
  </Text>
);

export default RenderText;
